import { Controller, useForm } from 'react-hook-form';
import {
  ConsultationAnswerFormSchema,
  DashboardHistoryPUBAnswerFormProps,
} from './DashboardHistoryPUBAnswerForm.types';
import { getConsultationAnswerSchema } from './DashboardHistoryPUBAnswerForm.schema';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation, useQueryClient } from 'react-query';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import {
  SEND_CONSULTATION_ANSWER_QUERY_KEY,
  sendConsultationAnswerQuery,
} from './DashboardHistoryPUBAnswerForm.query';
import { SendConsultationAnswerRequestData } from '../../../../../../../types/api/endpoints/consultations/answers.types';
import { useNavigate } from 'react-router-dom';
import TextArea from '../../../../../../commons/TextArea/TextArea';
import Button from '../../../../../../designSystem/Button/Button';

export default ({ questionId }: DashboardHistoryPUBAnswerFormProps) => {
  const queryClient = useQueryClient();

  const navigate = useNavigate();

  const formProps = useForm<ConsultationAnswerFormSchema>({
    resolver: yupResolver(getConsultationAnswerSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    formState: { isValid, errors },
  } = formProps;

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, SendConsultationAnswerRequestData>(
    (data) => sendConsultationAnswerQuery(data),
    {
      mutationKey: SEND_CONSULTATION_ANSWER_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        navigate(0);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onSubmit = handleSubmit((data) => mutate({ ...data, questionId }));

  return (
    <>
      <Controller
        name={'answer'}
        render={({ field: { onChange, value } }) => (
          <TextArea
            className="dashboard-history__question-textarea"
            name="answer"
            placeholder={'Votre réponse...'}
            error={errors['answer']?.message as string}
            // @ts-ignore
            value={value}
            // onPressEnter={onSubmit}
            {...{ onChange }}
            onlyInput
          />
        )}
        {...{ control }}
      />
      <Button
        className="dashboard-history__question-button"
        style={{ display: isValid ? 'unset' : 'none' }}
        onClick={onSubmit}>
        Envoyer
      </Button>
    </>
  );
};
